import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, ChevronRight, Timer } from "lucide-react";
import api from "../../lib/api";

export default function DriverOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/driver/orders")
      .then((r) => setOrders(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="label-overline text-jow-navy/55">Loading…</p>;

  if (orders.length === 0) {
    return (
      <div className="bg-white border border-jow-navy/10 p-10 text-center" data-testid="dorders-empty">
        <ClipboardList size={26} className="text-jow-gold mx-auto" />
        <p className="mt-3 font-display text-xl text-jow-navy">No assigned orders.</p>
        <p className="text-xs text-jow-navy/55 mt-1">When a manager assigns one, it shows up here.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="driver-orders">
      <div>
        <span className="label-overline text-jow-gold">Assigned</span>
        <h2 className="font-display text-3xl text-jow-navy mt-1">Your deliveries</h2>
      </div>

      <ul className="space-y-3">
        {orders.map((o) => (
          <li key={o.order_no} data-testid={`dorder-${o.order_no}`}>
            <Link
              to={`/driver/orders/${o.order_no}`}
              className="bg-white border border-jow-navy/10 hover:border-jow-gold/60 p-4 flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <p className="font-display text-base text-jow-navy flex items-center gap-2">
                  {o.order_no}
                  {o.type === "reservation" && (
                    <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-jow-pink border border-jow-pink px-2 py-0.5">
                      <Timer size={10} /> Reservation
                    </span>
                  )}
                </p>
                <p className="text-xs text-jow-navy/55 mt-0.5 truncate">
                  {o.items.length} items · {o.address?.city} · ₹{o.total.toLocaleString("en-IN")}
                </p>
              </div>
              <span
                className="text-[10px] uppercase tracking-widest px-2 py-1 border border-jow-navy/15"
                data-testid={`dorder-status-${o.order_no}`}
              >
                {o.status.replace("_", " ")}
              </span>
              <ChevronRight size={14} className="text-jow-navy/30" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
